import classNames from 'classnames';
import { MouseEventHandler, ReactNode } from 'react';
import { Button, ModalLayout, ModalLayoutProps } from 'yoso';
import { Content } from '~/components/Content';
import { ContentModel } from '~/components/Content/Content.hooks';
import { Close } from '~/components/Icon/Close';
import './ContentViewer.scss';

export type ContentViewerProps = Omit<ModalLayoutProps, 'id'> &
  ContentModel & {
    onConfirm?: MouseEventHandler;
    onDismiss?: MouseEventHandler;
    name?: string;
    footer?: ReactNode;
  };

export const ContentViewer = ({
  originContentsUrl,
  contentsType,
  contentsUrl,
  className,
  onDismiss,
  footer = null,
}: ContentViewerProps) => (
  <ModalLayout className={classNames('content-viewer', className, { ['has-footer']: footer })}>
    <div className="content-viewer-backdrop" onClick={onDismiss} />
    <div className="content-viewer-inner">
      <div className="content-viewer-body">
        <Content
          contentsType={contentsType}
          contentsUrl={contentsUrl}
          originContentsUrl={originContentsUrl}
          origin={true}
        />
      </div>
      <div className="content-viewer-footer">{footer}</div>
    </div>
    <Button type="button" className="close-button" round onClick={onDismiss}>
      <Close />
    </Button>
  </ModalLayout>
);
